<template>
  <div>
    <el-dialog
      :title="title"
      :visible.sync="dialogTableVisible"
      @close="colse"
      class="dialogbox"
      width="600px"
    >
      <el-form ref="form" :model="form" size="medium" :rules="rules">
        <el-form-item prop="name" label="用户名：">
          <el-input
            v-model="form.name"
            onkeyup="this.value=this.value.replace(/\s+/g,'')"
          ></el-input>
        </el-form-item>
        <el-form-item prop="mobile" label="联系电话：">
          <el-input v-model="form.mobile"></el-input>
        </el-form-item>
        <el-form-item prop="status" label="账号状态：">
          <el-radio-group v-model="form.status">
            <el-radio :label="1">正常</el-radio>
            <el-radio :label="0">禁止登录</el-radio>
          </el-radio-group>
        </el-form-item>
        <!-- <el-form-item prop="label" label="标签：">
          <el-input v-model="form.label"></el-input>
        </el-form-item> -->
        <el-form-item
          v-if="form.id"
          prop="password2"
          label="密码："
          onkeyup="this.value=this.value.replace(/\s+/g,'')"
        >
          <el-input
            type="password"
            v-model="form.password2"
            autocomplete="new-password"
          ></el-input>
        </el-form-item>
        <el-form-item
          v-if="form.id"
          prop="confirm_password2"
          label="确认密码："
          onkeyup="this.value=this.value.replace(/\s+/g,'')"
        >
          <el-input
            type="password"
            v-model="form.confirm_password2"
            autocomplete="new-password"
          ></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="quxiao">取 消</el-button>
        <el-button size="small" type="primary" @click="hei('form')"
          >确 定</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { postData } from "@/api";
export default {
  props: {
    msg: Object,
  },
  data() {
    // 设置手机号的验证规则
    var phoneRules = (rule, value, callback) => {
      const reg = /^1[3|4|5|6|7|8|9][0-9]\d{8}$/;
      if (reg.test(value)) {
        callback();
      } else {
        return callback(new Error("请输入正确的电话"));
      }
    };
    //第一次密码
    var validatePass = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请输入密码"));
      } else {
        if (this.form.confirm_password !== "") {
          this.$refs.form.validateField("confirm_password");
        }
        callback();
      }
    };
    //重复密码
    var validatePass2 = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请再次输入密码"));
      } else if (value !== this.form.password) {
        callback(new Error("两次输入密码不一致!"));
      } else {
        callback();
      }
    };
    var validatePass3 = (rule, value, callback) => {
      if (this.form.confirm_password2 !== "") {
        this.$refs.form.validateField("confirm_password2");
      }
      callback();
    };
    var validatePass4 = (rule, value, callback) => {
      if (value !== this.form.password2) {
        callback(new Error("两次输入密码不一致!"));
      } else {
        callback();
      }
    };
    return {
      title: "新增",
      dialogTableVisible: false,
      form: {
        id: "",
        account_name: "",
        mobile: "",
        name: "",
        password: "",
        confirm_password: "",
        status: 1, // 账号状态1启用0禁用
        remark: "",
        label: "",
      },
      //验证规则
      rules: {
        name: [
          { required: true, message: "请输入用户名", trigger: "blur" },
          {
            min: 2,
            max: 16,
            message: "长度在 2 到 16 个字符",
            trigger: "blur",
          },
        ],
        mobile: [
          { required: true, message: "请输入电话号码", trigger: "blur" },
          { validator: phoneRules, trigger: "blur" },
        ],
        password: [
          { required: true, validator: validatePass, trigger: "blur" },
          {
            min: 8,
            max: 16,
            message: "长度在 8 到 16 个字符",
            trigger: "blur",
          },
        ],
        confirm_password: [
          { required: true, validator: validatePass2, trigger: "blur" },
          {
            min: 8,
            max: 16,
            message: "长度在 8 到 16 个字符",
            trigger: "blur",
          },
        ],
        password2: [{ validator: validatePass3, trigger: "blur" }],
        confirm_password2: [{ validator: validatePass4, trigger: "blur" }],
      },
    };
  },
  created() {
    // console.log(this.msg,'弹出框加载值=================================');
    this.dialogTableVisible = this.msg.bool;
    this.title = this.msg.title;
    if (this.msg.bianji) {
      if (this.msg.bianji.id) {
        this.form.id = this.msg.bianji.id;
      } else {
        this.form.id = "";
      }
      this.form.account_name = this.msg.bianji.account_name;
      this.form.name = this.msg.bianji.name;
      this.form.mobile = this.msg.bianji.mobile;
      if (this.msg.bianji.status == null) {
        this.form.status = 1;
      } else {
        this.form.status = this.msg.bianji.status;
      }
      this.form.remark = this.msg.bianji.remark;
      this.form.label = this.msg.bianji.label;
    } else {
      this.form = {
        id: "",
        account_name: "",
        mobile: "",
        name: "",
        password: "",
        confirm_password: "",
        status: 1, // 账号状态1启用0禁用
        remark: "",
        label: "",
      };
    }
  },
  mounted() {},
  methods: {
    hei(formName) {
      let form;
      if (this.form.id) {
        form = {
          id: this.form.id,
          mobile: this.form.mobile,
          name: this.form.name,
          password: this.form.password2,
          status: this.form.status,
          label: this.form.label,
        };
      } else {
        form = {
          mobile: this.form.mobile,
          name: this.form.name,
          status: this.form.status,
          label: this.form.label,
        };
      }
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (this.title == "新增") {
            postData("UserController/addAction", form).then((res) => {
              if (res.code == 200) {
                this.$message({
                  message: "新增成功",
                  type: "success",
                });
                this.colse();
                this.$parent.esarchang();
              } else {
                this.$message.error(res.message);
              }
            });
          } else {
            postData("UserController/updateAction", form).then((res) => {
              if (res.code == 200) {
                this.$message({
                  message: "修改成功",
                  type: "success",
                });
                this.colse();
                this.$parent.esarchang();
              } else {
                this.$message.error(res.message);
              }
            });
          }
        } else {
          ("error submit!!");
          return false;
        }
      });
    },
    colse() {
      this.dialogTableVisible = false;
      this.$emit("guan", this.dialogTableVisible);
    },
    quxiao() {
      this.colse();
    },
  },
  watch: {
    dialogTableVisible() {
      // (this.form);
      // if (this.form.id) {
      //   // 验证密码是否合法
      //   this.rules.password = [
      //     { required: false, validator: this.validatePass, trigger: "blur" },
      //     {
      //       required: false,
      //       min: 6,
      //       max: 15,
      //       message: "长度在 6 到 15 个字符",
      //       trigger: "blur",
      //     },
      //   ];
      //   this.rules.confirm_password = [
      //     { required: false, validator: this.validatePass2, trigger: "blur" },
      //     {
      //       required: false,
      //       min: 6,
      //       max: 15,
      //       message: "长度在 6 到 15 个字符",
      //       trigger: "blur",
      //     },
      //   ];
      // } else {
      //   // 验证密码是否合法
      //   this.rules.password = [
      //     { required: true, validator: this.validatePass, trigger: "blur" },
      //     {
      //       required: true,
      //       min: 6,
      //       max: 15,
      //       message: "长度在 6 到 15 个字符",
      //       trigger: "blur",
      //     },
      //   ];
      //   this.rules.confirm_password = [
      //     { required: true, validator: this.validatePass2, trigger: "blur" },
      //     {
      //       required: true,
      //       min: 6,
      //       max: 15,
      //       message: "长度在 6 到 15 个字符",
      //       trigger: "blur",
      //     },
      //   ];
      // }
    },
  },
};
</script>

<style scoped lang="less"></style>
<style lang="less" src="@/assets/css/dialogbox.less" scoped></style>
